import { render, staticRenderFns } from "./ServiceAndSupport.vue?vue&type=template&id=0d51cefc&scoped=true&"
import script from "./ServiceAndSupport.vue?vue&type=script&lang=js&"
export * from "./ServiceAndSupport.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAndSupport.vue?vue&type=style&index=0&id=0d51cefc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d51cefc",
  null
  
)

export default component.exports